// extracted by mini-css-extract-plugin
module.exports = {"status":"_72d58f38 mr3 mv3 nowrap","enabled":"ef05047f","disabled":"_69f3a0ae"};